import dayjs from 'dayjs';

export function convertLocalDateTimeToEnd(date: dayjs.Dayjs) {
  const dayjsDate = dayjs(date);

  const year = dayjsDate.year();
  const month = dayjsDate.month() + 1;
  const day = dayjsDate.date();

  return `${year}-${month < 10 ? '0' + month : month}-${
    day < 10 ? '0' + day : day
  }T23:59:59.000Z`;
}
